import {observable, action, computed, toJS} from 'mobx';
import {v4 as uuidv4} from 'uuid';
import _ from 'lodash';

class AvailabilityWindowsTableState {
  @observable windows = [];

  receiveProps({windows, onChange}) {
    this.windows = windows;
    this.onChange = onChange;
  }

  @computed get sortedWindows() {
    return _.sortBy(this.windows, ['dayOfWeek']);
  }

  @action updateAvailabilityWindow(window, patch) {
    Object.assign(window, patch);
    this.onChange(toJS(this.windows));
  }

  @action addAvailabilityWindow(dayOfWeek) {
    this.windows.push({id: uuidv4(), dayOfWeek, startTimeString: '', endTimeString: ''});
    this.onChange(toJS(this.windows));
  }

  @action removeAvailabilityWindow(window) {
    this.windows.remove(window);
    this.onChange(toJS(this.windows));
  }
}

export default AvailabilityWindowsTableState;
